'use client'

import { useRouter } from 'next/navigation'
import * as React from 'react'

import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { FormField, Input } from '@/components/ui/form-controls'
import { loginAction } from '@/lib/crud/actions'
import { useT } from '@/lib/i18n/client'

export function LoginForm() {
  const router = useRouter()
  const { t } = useT()
  const [error, setError] = React.useState<string | null>(null)
  const [pending, startTransition] = React.useTransition()

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    setError(null)
    startTransition(async () => {
      const result = await loginAction(String(form.get('email') ?? ''), String(form.get('password') ?? ''))
      if (!result.ok) return setError(result.message)
      router.replace('/')
      router.refresh()
    })
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-4">
      {error && <Alert tone="danger">{error}</Alert>}
      <FormField label={t('ui.email')} htmlFor="email" required>
        <Input id="email" name="email" type="email" autoComplete="username" autoFocus required />
      </FormField>
      <FormField label={t('ui.password')} htmlFor="password" required>
        <Input id="password" name="password" type="password" autoComplete="current-password" required />
      </FormField>
      <Button type="submit" size="lg" disabled={pending}>
        {pending ? t('ui.signingIn') : t('ui.signIn')}
      </Button>
    </form>
  )
}
